import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import { categoryMeta } from "@/mocks/videos";

interface VideoCardProps {
  video: Video;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 69视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-950/80 text-background-50 text-xs font-medium">
          {categoryMeta[video.type].label}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-accent-500 text-primary-950 text-xs font-bold flex items-center gap-0.5">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {video.rating.toFixed(1)}
        </span>
      </div>

      <div className="p-3 flex flex-col gap-1.5 flex-1">
        <h3 className="font-semibold text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
          <span>{video.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{video.region}</span>
          {!compact && (
            <>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{video.duration}</span>
            </>
          )}
        </div>
        {!compact && (
          <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mt-0.5">{video.summary}</p>
        )}
      </div>
    </Link>
  );
}